import { useEffect, useState } from "react";
import { api, apiError } from "@/lib/api";
import { toast } from "sonner";
import { Loader } from "@/components/Loader";

export default function ReattemptsPage() {
  const [reqs, setReqs] = useState(null);
  const [choice, setChoice] = useState({});

  const load = () => api.get("/admin/reattempts", { params: { status: "pending" } }).then((r) => setReqs(r.data.requests)).catch((e) => toast.error(apiError(e)));
  useEffect(() => { load(); }, []);

  const approve = async (r) => {
    try { await api.post(`/admin/reattempts/${r.id}/approve`, { new_set_id: choice[r.id] || null }); toast.success("Reattempt approved"); load(); }
    catch (e) { toast.error(apiError(e)); }
  };
  const reject = async (r) => {
    try { await api.post(`/admin/reattempts/${r.id}/reject`); toast.success("Reattempt rejected"); load(); }
    catch (e) { toast.error(apiError(e)); }
  };

  if (!reqs) return <Loader />;

  return (
    <div className="space-y-6" data-testid="admin-reattempts">
      <h1 className="text-[32px] font-bold text-[#1c1b1b]">Reattempt Requests</h1>
      {reqs.length === 0 ? (
        <p className="text-sm text-[#434654] bg-white border border-[#E5E7EB] rounded-lg p-6" data-testid="reattempts-empty">No pending reattempt requests.</p>
      ) : (
        <div className="space-y-3">
          {reqs.map((r) => (
            <div key={r.id} data-testid={`reattempt-${r.id}`} className="bg-white border border-[#E5E7EB] rounded-lg p-5 flex items-center justify-between flex-wrap gap-3">
              <div>
                <p className="font-semibold text-[#1c1b1b]">{r.nurse_name}</p>
                <p className="text-sm text-[#434654]">{r.module_title} · Last score: {r.last_score != null ? `${r.last_score}%` : "—"}</p>
              </div>
              <div className="flex items-center gap-2">
                <select data-testid={`set-choice-${r.id}`} value={choice[r.id] || ""} onChange={(e) => setChoice({ ...choice, [r.id]: e.target.value })}
                  className="h-10 rounded-lg border border-[#E5E7EB] px-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#003d9b]">
                  <option value="">Same set</option>
                  {r.available_sets.map((s) => <option key={s.id} value={s.id}>{s.title}</option>)}
                </select>
                <button data-testid={`approve-reattempt-${r.id}`} onClick={() => approve(r)}
                  className="h-10 px-4 rounded-lg bg-[#003d9b] text-white font-semibold text-sm hover:bg-[#0052cc] transition-colors">Approve & Unlock</button>
                <button data-testid={`reject-reattempt-${r.id}`} onClick={() => reject(r)}
                  className="h-10 px-4 rounded-lg border border-[#ba1a1a]/30 text-[#ba1a1a] font-semibold text-sm hover:bg-red-50 transition-colors">Reject</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
